export default "__VITE_ASSET__BdcMrf9t__$_?url__"